module.exports = __webpack_public_path__ + "static/banking-bg-c68c2538d16071ae0b65c783e9cf3609.jpg";